import {
  ssColorBlack,
  ssColorWhite,
  ssColorBlue,
  ssColorLightGrey,
  ssColorDarkGrey,
  ssColorDarkNavy,
} from '../constants/style-constants';

const themeConfig = {
  agent_handler: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/60EuDVrPDP3PNIZ0mcNqOD/394b72e4fe1fadc734a205589e8cdc42/agent_handler.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  counter_intelligence_investigator: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/7CVrlA2gcpn3pBHRmC1CEg/eec965e88478f76c4f78cad9719a576d/counter_intelligence_investigator.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  cryptologist: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/5M5cvN1w8eJ5jZQKl7sCHA/8cd3a5472b1c1c73eb6f26073ea6f755/cryptologist.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  hacker: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/d8JvTOAVIIa2EPMXAfveE/2803cdf5a75d9bd77d78a18d78cfd5b3/hacker.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  intelligence_analyst: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/6JXyGXufqutXHbGzGCw7Vo/0ab03d2a0c659ab7c5653be4855271fe/intelligence_analyst.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  intelligence_operative: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/aNdFpN2AmcQrnlCjLTJou/36d0d47d67346073a463c28ee7127382/intelligence_operative.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  special_forces: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/717U0teNYIMSv5MUFTt9mj/c839abb1de6fce56cf1c26dedc0c41bf/special_forces.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  spymaster: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/6Hwn3VYPRtJirNJWpWWrVm/60001e22b8a8f9503ee6aeeb59d7d718/spymaster.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  surveillance: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/2xmpgIVXb4SMFAFeUa3Gdy/e5ba052ecbade70faee81638d8d159c2/surveillance.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  tech_ops: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/2mOlhjxDQR4TGyO76WUmws/275e9ddd72f82906c269cf2a7ce09c02/tech_ops.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
  blue: {
    backgroundImage: null,
    backgroundColor: ssColorBlue,
    colorScheme: 'dark',
  },
  light_grey: {
    backgroundImage: null,
    backgroundColor: ssColorLightGrey,
    colorScheme: 'light',
  },
  white: {
    backgroundImage: null,
    backgroundColor: ssColorWhite,
    colorScheme: 'light',
  },
  dark_navy: {
    backgroundImage: null,
    backgroundColor: ssColorDarkNavy,
    colorScheme: 'dark',
  },
  grey: {
    backgroundImage: null,
    backgroundColor: ssColorDarkGrey,
    colorScheme: 'dark',
  },
  black: {
    backgroundImage: null,
    backgroundColor: ssColorBlack,
    colorScheme: 'dark',
  },
  default: {
    backgroundImage: 'https://images.ctfassets.net/gtqjh9j40j4m/3wVissRJyimDPXd5gJ0gKh/89f400aa482d205cd156c423c14524ea/none.jpg?fm=jpg&q=70',
    backgroundColor: null,
    colorScheme: 'dark',
  },
};

const selectPageSectionCSS = (themeKey) => {
  if (!themeConfig[themeKey]) {
    throw new Error(`PageSection theme key "${themeKey}" is not valid. Check for typos.`);
  }

  const {
    backgroundImage,
    colorScheme,
    backgroundColor,
  } = themeConfig[themeKey];

  const backgroundColorCSS = `
    background-color: ${backgroundColor || 'transparent'};
  `;

  const backgroundImageCSS = backgroundImage ? `
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: top center;
  ` : '';

  const backgroundCSS = `
    ${backgroundColorCSS};
    ${backgroundImageCSS};
  `;

  return {
    textColor: colorScheme === 'light' ? ssColorBlack : ssColorWhite,
    backgroundCSS,
  };
};

export default selectPageSectionCSS;
